import React from 'react';
import { ReferenceInput } from 'react-admin';
import Grid from '@material-ui/core/Grid';
import ReferenceChild from '../../components/ReferenceChild';

import { perPage } from '../../helper';

const UnifiedEditCoupon = (props) => {
  const { handleCouponChange = () => {} } = props;
  return (
    <Grid item xs={12} sm={10} md={8} className="schedule_work_section" style={{ margin: '0 0 0 auto' }}>
      <ReferenceInput
        source="coupon_code"
        reference="coupon"
        perPage={perPage}
        sort={{ field: 'coupon_code', order: 'ASC' }}
        allowEmpty
      >
        <ReferenceChild
          {...props}
          optionText="coupon_code"
          source="coupon_code"
          onChange={handleCouponChange}
        />
      </ReferenceInput>
    </Grid>
  );
};

export default UnifiedEditCoupon;
